import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'
import { Customer } from '../types'

const loadCustomer = (id?: string): Response<Customer> => {
  return axios.get(`/customers/${id}`)
}

export function useLoadCustomer(id?: string) {
  return useQuery(['orders', id], () => loadCustomer(id), {
    enabled: !!id,
    onError: () =>
      toast.error('Não foi possível carregar o cliente', {
        toastId: 'customer'
      })
  })
}
